import type { ToBeReviewedItem } from './buildToBeReviewed';

type AlertIdItem = {
  id?: string;
};

/**
 * Merge newly consumed To Be Reviewed alert ids into the SignalR-active set.
 */
export const mergeActiveToBeReviewedAlertIds = (
  activeIds: Set<string> | Iterable<string> | null | undefined,
  newItems: AlertIdItem[] = []
): Set<string> => {
  if (!newItems.length) {
    return activeIds instanceof Set ? activeIds : new Set(activeIds || []);
  }

  const next = new Set(activeIds || []);
  newItems.forEach((item) => {
    if (item?.id) {
      next.add(item.id);
    }
  });
  return next;
};

/**
 * Keep only notification cards whose ids are in the active SignalR alert set.
 */
export const filterActiveToBeReviewedNotifications = <T extends { id: string }>(
  items: T[] = [],
  activeIds: Set<string> | Iterable<string> | null | undefined
): T[] => {
  const active = activeIds instanceof Set ? activeIds : new Set(activeIds || []);
  return items.filter((item) => active.has(item.id));
};

export type { ToBeReviewedItem };
